import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const freezeCardActions = createDataModuleActions('FREEZE_CARD', {
    dataRequest: (cardUuid) => ({ cardUuid }),
});
export const freezeCard = freezeCardActions.dataRequest;
export const freezeCardSuccess = freezeCardActions.dataSuccess;
export const freezeCardError = freezeCardActions.dataError;
export const freezeCardReset = freezeCardActions.dataReset;

const unfreezeCardActions = createDataModuleActions('UNFREEZE_CARD', {
    dataRequest: (cardUuid) => ({ cardUuid }),
});
export const unfreezeCard = unfreezeCardActions.dataRequest;
export const unfreezeCardSuccess = unfreezeCardActions.dataSuccess;
export const unfreezeCardError = unfreezeCardActions.dataError;
export const unfreezeCardReset = unfreezeCardActions.dataReset;
